import styled, { css } from 'styled-components';
import { theme } from 'styled-tools';

import DefaultButton from '../Button';

export const StyledButton = styled(DefaultButton)<{
	$width?: string;
	$height?: string;
}>`
	${props => props.$width && `width: ${props.$width};`}
	${props => props.$height && `height: ${props.$height};`}
	border-radius: ${theme('buttons.iconButtons.borderRadius')};
	box-shadow: ${props => (props.isDisabled ? null : theme('buttons.iconButtons.shadow'))};
	&:after {
		border-radius: ${theme('buttons.iconButtons.borderRadius')};
		box-shadow: ${theme('buttons.iconButtons.focusShadow')};
	}

	&:before {
		background: ${theme('buttons.iconButtons.hoverBackground')};
		box-shadow: ${theme('buttons.iconButtons.hoverShadow')};
		border-radius: ${theme('buttons.iconButtons.borderRadius')};
		transition: ${theme('animation.transition')};
	}

	${props =>
		props.isDisabled || props.isLoading
			? null
			: css`
					&:active {
						box-shadow: ${theme('buttons.iconButtons.pressedBorderShadow')};
						text-shadow: ${theme('buttons.iconButtons.pressedTextShadow')};

						&:before {
							box-shadow: ${theme('buttons.iconButtons.pressedInnerShadow')};
							opacity: 1;
						}
					}
				`}
`;
